import ModalMineralCountriesListItem from './ModalMineralCountriesListItem'

export default function ModalMineralCountriesList({ countries, mineralId, fetchCountries }) {
  return countries?.map((country) => (
    <ModalMineralCountriesListItem
      key={country.id}
      country={country}
      mineralId={mineralId}
      fetchCountries={fetchCountries}
    />
  ))
}
